import React, { useEffect, useState } from "react";
import {
	IconButton,
	Badge,
	Menu,
	MenuItem,
	Typography,
	Box,
	Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "contexts/AuthContext";
import { deleteAlert, getAlerts } from "api/firestore/services/alertService";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckIcon from "@mui/icons-material/Check";

const Alerts = () => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [alerts, setAlerts] = useState([]);
	const isOpen = Boolean(anchorEl);

	const { t } = useTranslation();
	const { currentUser } = useAuth();

	const load = React.useCallback(async () => {
		let alerts = await getAlerts(currentUser.uid);
		setAlerts(alerts);
	}, [currentUser.uid]);

	useEffect(() => {
		load();
	}, [load]);

	const handleBellClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleConfirmAlert = async (index) => {
		const updatedAlerts = [...alerts];
		await deleteAlert(currentUser.uid, alerts[index].ID);
		updatedAlerts.splice(index, 1);
		setAlerts(updatedAlerts);
	};

	const handleClearAll = async () => {
		for (let alert of alerts) {
                        await deleteAlert(currentUser.uid, alert.ID).catch((error) => {
                                console.error(error);
                        });
		}

		setAlerts([]);
	};

	return (
		<div>
			<IconButton
					color="inherit"
					onClick={handleBellClick}
					sx={{ color: "var(--primary-contrast)" }}
				>
				<Badge
					badgeContent={
						alerts.length > 0 ? (
							alerts.length
						) : (
							<CheckCircleIcon style={{ color: "green", width: 15 }} />
						)
					}
					color={alerts.length > 0 ? "error" : "default"}
				>
					<NotificationsIcon />
				</Badge>
			</IconButton>

			<Menu
				anchorEl={anchorEl}
				open={isOpen}
				onClose={handleClose}
				PaperProps={{
					style: {
						width: 300,
						maxHeight: 400,
						overflowY: "auto",
					},
				}}
			>
				{alerts.length > 0 ? (
					[
						<MenuItem key="clear-all">
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={handleClearAll}
							>
								Clear
							</Button>
						</MenuItem>,
						...alerts.slice(0, 10).map((alert, index) => (
							<MenuItem key={index}>
								<Box display="flex" flexDirection="column" width="100%">
									<Typography variant="body1" style={{ fontWeight: "bold" }}>
										{alert.Type}
									</Typography>
									<Typography
										variant="body2"
										style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
									>
										{alert.Description}
									</Typography>
								</Box>
								<IconButton
									edge="end"
									size="small"
									color="primary"
									onClick={() => handleConfirmAlert(index)}
								>
									<CheckIcon />
								</IconButton>
							</MenuItem>
						))
					]
				) : (
					<MenuItem onClick={handleClose}>
						<Typography variant="body2">{t("no-alerts")}</Typography>
					</MenuItem>
				)}
			</Menu>
		</div>
	);
};

export default Alerts;
